import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type AssetPerformanceLineDataDashboard } from '../services/getAssetPerformanceRegisterData'

export interface flameRegisterAssetDataState {
  isLoading: boolean
  errorMessage: string | null
  flameRegisterAssetData: AssetPerformanceLineDataDashboard | null
  httpStatus: number | null
}

// Initial state of the slice

const initialState: flameRegisterAssetDataState = {
  flameRegisterAssetData: null,
  isLoading: false,
  errorMessage: null,
  httpStatus: null
}

// Slice to return from action
export const flameRegisterGraphDataState = createSlice({
  name: 'flameRegisterAssetDataState',
  initialState,
  reducers: {
    flameRegisterGraphDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        flameRegisterAssetData: null,
        isLoading: true,
        errorMessage: null,
        httpStatus: 0
      }
    },
    flameRegisterGraphDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        flameRegisterAssetData: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    },
    flameRegisterGraphDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        flameRegisterAssetData: null,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  flameRegisterGraphDataLoadingAction,
  flameRegisterGraphDataUpdateAction,
  flameRegisterGraphDataErrorAction
} = flameRegisterGraphDataState.actions

export default flameRegisterGraphDataState.reducer
